<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="@/assets/paynec/Vector@2x (6).png" style="width: 16px; height: 16px" />
				<div class="cement">我的客户</div>
			</div>
			<div class="border-top"></div>
			<div>
				<div class="Orders-pending">
					<div>
						<div class="order-number">{{ reportData?.yesterdayCustomerCount || 0 }}</div>
						<div class="order-title">昨日新增客户数</div>
					</div>
					<div class="border-taops"></div>
					<div>
						<div class="order-number">{{ reportData?.yesterdayCustomerOrderCount || 0 }}</div>
						<div class="order-title">昨日成交客户数</div>
					</div>
					<div class="border-taops"></div>
					<div>
						<div class="order-number">{{ reportData?.customerCount || 0 }}</div>
						<div class="order-title">累计客户数</div>
					</div>
				</div>
				<div class="border-top"></div>
				<el-table :data="dataList" height="250" style="width: 100%">
					<el-table-column label="手机号">
						<template #default="scope">
							{{ hideMobile(scope.row.mobile) }}
						</template>
					</el-table-column>
					<el-table-column label="累计交易面值">
						<template #default="scope">
							{{ numPretty(scope.row.totalSourceAmount) }}
						</template>
					</el-table-column>
					<el-table-column prop="totalOrderCount" label="累计交易次数" />
					<el-table-column prop="proxyAmount" label="累计佣金" >
						<template #default="scope">
							{{ numPretty(scope.row.proxyAmount) }}
						</template>
					</el-table-column>
					<el-table-column prop="lastOrderTime" label="最近交易时间">
						<template #default="scope">
							{{ dateFormatter(scope.row.lastOrderTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="address" label="绑定时间" >
						<template #default="scope">
							{{ dateFormatter(scope.row.createTime) }}
						</template>
					</el-table-column>
				</el-table>

				<!-- <div style="display: flex; align-items: center; justify-content: space-between">
					<div class="pagination-contact">
						<el-pagination background layout="total, prev, pager, next,jumper" :total="0" />
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script setup>
import BigNumber from 'bignumber.js';
import { ref, onMounted } from 'vue';
import { queryProxyCustomerReport, queryProxyCustomerList } from '@/utils/api.js';
const reportData = ref({});
const dataList = ref([]);
import dayjs from 'dayjs';

const info = async () => {
	const res = await queryProxyCustomerReport({});
	reportData.value = res.data;
};

function dateFormatter(time) {
	if (!time) {
		return '--';
	}
	return dayjs(time).format('YYYY-MM-DD');
}

const into = async () => {
	const res = await queryProxyCustomerList({});
	dataList.value = res.data;
};

const hideMobile = (mobile) => {
	if (!mobile) {
		return '';
	}
	return mobile.substring(0, 3) + '****' + mobile.substring(8);
};

const numPretty = (num)=>{
	if (!num) {
	  return '￥0.00';
	}
	let tmp = new BigNumber(num);
	if (tmp.isNaN()) {
	  return '￥0.00';
	}
	return '￥' + tmp.toFixed(2);
}

onMounted(() => {
	info();
	into();
});
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1 {
	margin-top: 80px;
}
.title-tots {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector {
	width: 94%;
	background: #fff5f5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd {
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #db8a8a;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}

.Orders-pending {
	margin-top: 24px;
	margin-left: 12px;
	display: flex;
	align-items: flex-end;
}
.order-number {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 24px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.order-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.border-taops {
	width: 1px;
	height: 18px;
	border-left: 1px solid #eeeeee;
	padding-right: 43px;
	margin-left: 43px;
}
</style>
